<script>
  import { link } from 'svelte-routing';
</script>

<div class="main-header">
  <h1>
    <a href="/" use:link>Adopciones Norte</a>
  </h1>
  <h2>Vida digna y un hogar, eso queremos lograr</h2>
</div>

<style>
  .main-header {
    margin-bottom: 3%;
    color: white;
    height: 300px;
    background-color: #e5343e;
    text-align: center;
    width: 100%;
  }

  .main-header > h2 {
    color: rgb(19, 19, 19);
  }

  a, a:visited {
    color: white;
    text-decoration: none;
    background-image: none !important;
  }

  @media screen and (max-width: 767px) {
    h2 {
      display: none;
    }
  }
</style>